import { render } from "./BanobagiLayout.vue?vue&type=template&id=acea4898&scoped=true"
import script from "./BanobagiLayout.vue?vue&type=script&lang=js"
export * from "./BanobagiLayout.vue?vue&type=script&lang=js"

import "./BanobagiLayout.vue?vue&type=style&index=0&id=acea4898&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acea4898"]])

export default __exports__